import {jwtDecode} from 'jwt-decode';

export const getUserFromToken = (token: string) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};

export const isTokenValid = () => {
  console.log("validating")
  const token = localStorage.getItem("access_token");
  if (!token) {
    return false;
  }

  const tokenExpiry = localStorage.getItem('token_expiry');

  try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));

    const currentTimeInSeconds = Math.floor(Date.now() / 1000); 
    if (
      (decodedToken.exp && decodedToken.exp < currentTimeInSeconds) || 
      (tokenExpiry && !isNaN(Number(tokenExpiry)) && Number(tokenExpiry) < Date.now())
    ) {
      return false;
    }
  } catch (e) {
    console.error("Error decoding the token", e);
    return false;
  }

  return true;
};

